window.waitForCondition(isJQueryPresent, () => {

    window._variantChange = function (variant, optionPrice) {
        if (window.document.querySelector('#case-number option')) {
            window.document.querySelectorAll('#case-number option').forEach((element) => {
                let current = element;
                let num = element.value || 4;
                if (element.getAttribute('data-id') == variant.id) {

                    window.document.querySelectorAll('.case-cta .info .quantity').forEach((el) => {
                        el.innerText = element.value;
                    });

                    window.document.querySelectorAll('#case_quantity option')[0].setAttribute('selected', 'selected');
                    window.document.querySelector('#case_quantity').value = window.document.querySelectorAll('#case_quantity option')[0].value;

                    window.document.querySelectorAll('.subscription-radio .price-label').forEach((el) => {
                        el.innerText = element.getAttribute('data-sprice');
                    });

                    window.document.querySelectorAll('.onetime-radio .price-label').forEach((el) => {
                        el.innerText = optionPrice;
                    })
                }
            });
        }
        servingsHandler(variant, optionPrice);
    };

    if (!customElements.get('product-main')) {
        class ProductMain extends HTMLElement {
            constructor() {
                super();
                this.sectionId = this.dataset.section;
                this.productData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
                this.productData.variants = this.productData.variants.filter(function(variant) {
                  return !window.hidden_variants.includes(variant.id);
                });
                this.variantsElement = this.querySelector('product-variants');
            }

            getCurrentVariant() {
                return this.variantsElement.getCurrentVariant();
            }
        }


        customElements.define('product-main', ProductMain);

        class ComponentProductCardAtc extends ProductMain {
            constructor() {
                super()
                this.swatches = this.querySelector('.swatch-group')
                this.addEventListener('variantChange', this.onVariantChange.bind(this));
                this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
                if (this.classList.contains('colors-out')) {
                    this.colorSwatches = this.querySelector('product-swatch.color-swatches');
                    if (this.colorSwatches) {
                        this.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', this.colorSwatches);
                    }
                }

            }

            onVariantChange(event) {
                var image = event.detail.variant.featured_image;
                var img = this.querySelector('.img.main');
                var width = Math.ceil(img.width / 100) * 100;
                img.setAttribute('srcset', image ? $s.imgUrlFilter(image.src, width + 'x') : this.defaultImage)
            }
        }

        customElements.define('product-card-atc', ComponentProductCardAtc);

    }

    if (!customElements.get('view-ingredients')) {
        class ViewIngredients extends HTMLElement {
            constructor() {
                super();
                this.mainElement = this.closest('.product-main-element');
                this.viewIngredientsTrigger = this.querySelector('view-ingredients .trigger');
                this.viewIngredientsTrigger.addEventListener('click', this.handleViewIngredients.bind(this));
                this.mainElement.addEventListener('variantChange', (e) => {
                    if (this.getCurrentPanel()) {
                        this.style.display = 'block';
                    } else {
                        this.style.display = 'none';
                    }
                });

            }

            getCurrentPanel() {
                var variant = this.mainElement.getCurrentVariant();
                var item = this.viewIngredientsTrigger.closest('view-ingredients');
                return item.querySelector('[data-variant-id="' + (variant ? variant.id : '') + '"], .product-ingredients');
            }

            handleViewIngredients(e) {
                e.preventDefault();
                var item = this.viewIngredientsTrigger.closest('view-ingredients');
                var panel = item.querySelector('.panel');
                item.querySelectorAll('.ingredients-panel').forEach(function (panel) {
                    panel.style.display = 'none';
                });
                this.getCurrentPanel().style.display = 'block';

                $s.openModal(panel, 'view-ingredients-popup');
            }
        }

        customElements.define('view-ingredients', ViewIngredients);
    }

    if (!customElements.get('view-description')) {
        class ViewDescription extends HTMLElement {
            constructor() {
                super();
                this.mainElement = this.closest('.product-main-element');
                this.mainElement.addEventListener('variantChange', (e) => {
                    var currentPanel = this.getCurrentPanel();
                    this.querySelectorAll('.description-panel').forEach(x => x.style.display = 'none');
                    if (currentPanel) {
                        currentPanel.style.display = 'block';
                        this.style.display = 'block';
                    } else {
                        this.style.display = 'none';
                    }
                });

            }

            getCurrentPanel() {
                var variant = this.mainElement.getCurrentVariant();
                return this.querySelector('[data-variant-id="' + (variant ? variant.id : '') + '"], .product-description');
            }
        }

        customElements.define('view-description', ViewDescription);
    }

    if (!customElements.get('product-nutrition-facts')) {
        class ProductNutritionFacts extends HTMLElement {
            constructor() {
                super();
                this.mainElement = document.querySelector('.product-main-element');
                this.mainElement.addEventListener('variantChange', (e) => {
                    var currentSliderDesktop = this.getCurrentSlider('desktop');
                    var currentSliderMobile = this.getCurrentSlider('mobile');

                    this.querySelectorAll('.keen-slider').forEach(x => x.style.display = 'none');
                    this.querySelectorAll('.keen-dots').forEach(x => x.style.display = 'none');

                    if (currentSliderDesktop) {
                        currentSliderDesktop.style.display = 'flex';
                        currentSliderDesktop.closest('.keen').querySelector('.keen-dots').style = 'block';
                    }
                    if (currentSliderMobile) {
                        currentSliderMobile.style.display = 'flex';
                        currentSliderMobile.closest('.keen').querySelector('.keen-dots').style = 'block';
                    }

                    if (currentSliderDesktop || currentSliderMobile) {
                        this.style.display = 'block';
                    } else {
                        this.style.display = 'none';
                    }
                });
            }

            getCurrentSlider(size) {
                var variant = this.mainElement.getCurrentVariant();
                return this.querySelector('.keen-slider.variant-' + variant.id + '-nutritional-' + size);
            }
        }

        customElements.define('product-nutrition-facts', ProductNutritionFacts);
    }

    if (!customElements.get('product-buttons')) {
        class ProductButtons extends HTMLElement {
            constructor() {
                super();
                this.mainElement = document.querySelector('.product-main-element');
                this.dynamicButtons = this.querySelector('.shopify-payment-button');

                this.mainElement.addEventListener('variantChange', (e) => {
                    if (e.detail.variant && e.detail.variant.available) {
                        if (this.dynamicButtons) {
                            this.dynamicButtons.classList.remove('hide');
                        }
                        this.querySelector('.btn.add').style.display = '';
                        this.querySelector('.sold-out-message').style.display = 'none';
                    } else {
                        if (this.dynamicButtons) {
                            this.dynamicButtons.classList.add('hide');
                        }
                        this.querySelector('.btn.add').style.display = 'none';
                        this.querySelector('.sold-out-message').style.display = '';
                    }
                });
            }
        }

        customElements.define('product-buttons', ProductButtons);
    }

    if (!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
        class ProductMedia extends HTMLElement {
            constructor() {
                super();
                this.mainElement = this.closest('.product-main-element');
                this.itemsWrapper = this.querySelector(':scope > div');
                this.desktopStyle = this.dataset.desktop;
                this.mobileStyle = this.dataset.mobile;
                this.slider = false;

                this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
                window.addEventListener('mediaChange', this.onMediaChange.bind(this))
                setTimeout(() => {
                    this.onMediaChange();
                }, 10);
            }

            filterMedia(variant) {
                let mediaImages = 0;
                this.mainElement.productData.media.forEach((media) => {
                    var show = true;
                    if (media.alt && media.alt != "") {
                        var filter = media.alt.split(';');
                        filter.forEach((f) => {
                            if (show) {
                                var key = f.split(':')[0];
                                var values = f.split(':')[1];
                                var optionIndex = this.mainElement.productData.options.findIndex(x => x == key);
                                if (optionIndex >= 0) {
                                    var found = false;
                                    values.split(',').forEach((value) => {
                                        if (variant.options[optionIndex] == value) {
                                            found = true;
                                            mediaImages += 1;
                                        }
                                    });
                                    show = found;
                                } else {
                                    mediaImages += 1;
                                }
                            }
                        });
                    }
                    if (show) {
                        this.querySelector('[data-media-id="' + media.id + '"]').style.display = 'block';
                    } else {
                        this.querySelector('[data-media-id="' + media.id + '"]').style.display = 'none';
                    }
                });

                if (this.slider) {
                    this.slider.refresh();
                }

                // Show dots or arrows only if more than one image per variant in carousel
                const dots = this.mainElement.querySelector('.main-product-grid .keen-dots');
                const arrows = this.mainElement.querySelector('.main-product-grid .keen-arrows');
                if (mediaImages < 2) {
                    if (dots) {
                        dots.style.visibility = 'hidden';
                    }
                    if (arrows) {
                        arrows.style.visibility = 'hidden';
                    }
                } else {
                    if (dots) {
                        dots.style.visibility = 'visible';
                    }
                    if (arrows) {
                        arrows.style.visibility = 'visible';
                    }
                }
            }

            onVariantChange() {
            }

            onMediaChange() {
            }

            initSlider() {
            }

            removeSlider() {
                if (this.slider) {
                    this.slider.destroy();
                    this.slider = false;
                    this.classList.remove('keen');
                    this.itemsWrapper.classList.remove('keen-slider');
                    this.querySelectorAll(':scope > div').forEach((slide) => {
                        slide.classList.remove('keen-slider-slide')
                    });
                }
            }

            showItem(mediaId, animate = true) {
                if (this.slider) {
                    var index = Array.from(this.itemsWrapper.querySelectorAll(':scope > div'))
                        .filter(x => $s.isVisible(x)).findIndex(x => x.dataset.mediaId == mediaId);
                    if (animate) {
                        this.slider.moveToSlideRelative(index, true);
                    } else {
                        this.slider.moveToSlideRelative(index, true, 0);
                    }
                }
            }
        }


        class ProductGallery extends ProductMedia {
            constructor() {
                super();

                if (!this.closest('.tingle-modal')) {
                    this.querySelectorAll('[data-file]').forEach((media) => {
                        media.addEventListener('click', (e) => {
                            var visibleItems = [];
                            this.querySelectorAll('[data-media-id]').forEach((obj) => {
                                if ($s.isVisible(obj)) {
                                    let element = obj.querySelector('[data-file], video, iframe');
                                    if (element) {
                                        visibleItems.push(element);
                                    }
                                }
                            });
                            $s.photoSwipe(visibleItems, media);
                        });
                    });
                    //3D Models
                    this.querySelectorAll('[data-media-id].model-wrap').forEach((model) => {
                        model.addEventListener('click', (e) => {
                            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);
                        });
                    });
                }
            }

            onVariantChange(e) {
                var variant = e.detail.variant;
                var animate = e.detail.animate;
                if (this.mainElement.productData.media && variant) {
                    this.filterMedia(variant)
                    if (variant.featured_media) {
                        this.showItem(variant.featured_media.id, animate)
                    }
                }
            }

            onMediaChange() {
                if ($s.media.isSmall || this.desktopStyle == 'carousel' || this.desktopStyle == 'arrows') {
                    this.initSlider();
                } else {
                    this.removeSlider();
                }
            }

            initSlider() {
                if (!this.slider) {
                    this.classList.add('keen');
                    this.itemsWrapper.classList.add('keen-slider');
                    this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide) => {
                        slide.classList.add('keen-slider-slide')
                    });

                    this.slider = new KeenSlider(this.itemsWrapper, {
                        mode: "snap",
                        loop: true,
                        wheel: false,
                        prevButton: this.querySelector('.keen-arrow.prev'),
                        nextButton: this.querySelector('.keen-arrow.next'),
                        slideChanged: (keen) => {
                            $s.pauseAllMedia(this);
                            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
                        }
                    });
                }
            }
        }


        customElements.define('product-gallery', ProductGallery);

        class ProductThumbs extends ProductMedia {
            constructor() {
                super();
                this.mainGallery = this.mainElement.querySelector('product-gallery');

                this.querySelectorAll('[data-media-id]').forEach((media) => {
                    media.addEventListener('click', (e) => {
                        this.mainGallery.showItem(media.dataset.mediaId);
                    });
                });

                this.mainGallery.addEventListener('slideChanged', (e) => {
                    var currentSlide = e.detail.currentSlide();
                    if (currentSlide) {
                        var currentMediaId = currentSlide.dataset.mediaId;
                        var currentSlideElement = this.querySelector('.current-slide');
                        if (currentSlideElement) {
                            currentSlideElement.classList.remove('current-slide');
                        }
                        this.querySelector('[data-media-id="' + currentMediaId + '"]').classList.add('current-slide');
                    }
                });
            }

            onVariantChange(e) {
                var variant = e.detail.variant;
                if (this.mainElement.productData.media && variant) {
                    this.filterMedia(variant)
                }
            }

            onMediaChange() {
                if (($s.media.isSmall && this.mobileStyle == 'thumbnails') || ($s.media.isMediumUp && this.desktopStyle == 'carousel')) {
                    this.style.display = 'block';
                    this.initSlider();
                } else {
                    this.style.display = 'none';
                    this.removeSlider();
                }
            }

            initSlider() {
                if (!this.slider) {
                    this.classList.add('keen');
                    this.itemsWrapper.classList.add('keen-slider');
                    this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide) => {
                        slide.classList.add('keen-slider-slide')
                    });
                    var breakpoints = {};
                    breakpoints['(max-width: ' + window.breakpoints.medium + ')'] = {
                        slidesPerView: 4,
                        spacing: 10
                    }
                    breakpoints['(max-width: ' + window.breakpoints.small + ')'] = {
                        slidesPerView: 5,
                        spacing: 10
                    }
                    this.slider = new KeenSlider(this.itemsWrapper, {
                        mode: "snap",
                        loop: true,
                        centered: true,
                        slidesPerView: 7,
                        spacing: 15,
                        prevButton: this.querySelector('.keen-arrow.prev'),
                        nextButton: this.querySelector('.keen-arrow.next'),
                        breakpoints
                    });
                }
            }
        }


        customElements.define('product-thumbs', ProductThumbs);
    }

    if (!customElements.get('product-price')) {
        class ProductPrice extends HTMLElement {
            constructor() {
                super();
                this.mainElement = this.closest('.product-main-element');
                this.dealElement = this.querySelector('.deal');
                this.retailElement = this.querySelector('.retail');

                ['variantChange', 'sellingPlanChange'].forEach((event) => {
                    this.mainElement.addEventListener(event, (e) => {
                        var data = e.detail.variant || e.detail.sellingPlan;
                        if (!data) {
                            data = this.mainElement.getCurrentVariant();
                        }
                        if (data) {
                            this.dealElement.innerHTML = $s.formatMoney(data.price);

                            if (data.compare_at_price > data.price) {
                                this.retailElement.classList.remove('hide');
                                this.retailElement.innerHTML = $s.formatMoney(data.compare_at_price);
                            } else {
                                this.retailElement.classList.add('hide');
                                this.retailElement.innerHTML = '';
                            }
                        } else {
                            this.dealElement.innerHTML = '';
                            this.retailElement.innerHTML = '';
                        }
                    });
                });
            }
        }

        customElements.define('product-price', ProductPrice);
    }

    if (!customElements.get('product-variants')) {
        class ProductVariants extends HTMLElement {
            constructor() {
                super();
                this.firstRender = true;
                this.mainElement = this.closest('.product-main-element');
                this.variantInput = this.querySelector('[data-variant-id]');
                this.variantTitle = this.querySelector('.variant-title');
                this.toggleDebounce = null;
                document.addEventListener("click", e => {
                    if (!this.contains(e.target)) {
                        this.classList.contains("open") && this.classList.remove("open");
                    } else {
                        this.toggleMenu();
                    }
                });
                this.bindOptions();
                setTimeout(() => {
                    this.variantChange(this.getCurrentVariant(), false);
                }, 10);

                if (this.variantTitle)
                    this.variantTitle.textContent = this.getCurrentVariant().option1;
            }

            toggleMenu() {
                if (this.firstRender) {
                    this.firstRender = false;
                    return;
                }
                if (this.toggleDebounce) {
                    clearTimeout(this.toggleDebounce);
                    this.toggleDebounce = null;
                }
                this.toggleDebounce = setTimeout(() => {
                    this.classList.toggle("open");
                }, 100);
            }

            getCurrentVariant() {
                return this.mainElement.productData.variants.find(x => x.id == this.variantInput.value)
            }

            setVariant(variant) {
                if (typeof variant !== 'object') {
                    variant = this.mainElement.productData.variants.find(x => x.id == variant);
                }
                if (variant) {
                    this.refreshOptions(-1, variant);
                    this.variantChange(variant);
                }
            }

            variantChange(variant, animate = true) {
                let optionPrice = $s.formatMoney(variant.price);
                if (variant) {
                    this.variantInput.value = variant.id;
                } else {
                    this.variantInput.value = '';
                }
                this.previousVariant = variant;
                this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
                this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

                //var sPrice = $('.subscription-radio .price-label').text();
                window._variantChange(variant, optionPrice);
                this.toggleMenu();
                // $('#case-number option').each(function(){
                //   var current = $(this);
                //   var num=$('#case_quantity').val();
                //   if($(this).attr('data-id') == variant.id){
                //     $('.case-cta .info .quantity').text($(this).val());
                //     $('#case_quantity option:eq(0)').prop('selected', 'selected');
                //     $('.subscription-radio .price-label').text($(this).attr('data-sprice'));
                //     $('.onetime-radio .price-label').text(optionPrice);
                //     //setTimeout(function() { current.attr('data-sprice', $('.subscription-radio .price-label').text());},1000);
                //     // var variantPrice = $(this).attr('data-price').split('$')[1];
                //     //   var subsPrice = $(this).attr('data-sprice').split('$')[1];
                //    // debugger;

                //     // setTimeout(function() {
                //     //   debugger;
                //     //   $('.subscription-radio .price-label').text('$'+(subsPrice).toFixed(2));
                //     //  $('.onetime-radio .price-label').text('$'+(optionPrice).toFixed(2));
                //     // },1500);
                //     // setTimeout(function() { $('.subscription-radio .price-label').text('$'+(subsPrice*num).toFixed(2));
                //     // $('.onetime-radio .price-label').text('$'+(variantPrice*num).toFixed(2));},1500);
                //   }
                // });

            }

            calculateNewVariant(optionChanged, value) {
                var newVariants = this.mainElement.productData.variants;
                this.mainElement.productData.options.forEach((option, index) => {
                    if (optionChanged == index) {
                        newVariants = newVariants.filter(x => x.options[index] == value);
                    } else {
                        var tmpNewVariants = newVariants.filter(x => x.options[index] == this.previousVariant.options[index]);
                        if (tmpNewVariants.length == 0) {
                            tmpNewVariants = newVariants.filter(x => x.options[index] == newVariants[0].options[index]);
                        }
                        newVariants = tmpNewVariants;
                    }
                });
                return newVariants[0];
            }

            bindOptions() {
                this.querySelectorAll('[data-option]').forEach((element) => {
                    element.addEventListener('change', (e) => {
                        let optionIdx = element.dataset.option - 1;
                        let variant = this.calculateNewVariant(optionIdx, e.target.value);
                        this.refreshOptions(element.dataset.option - 1, variant);
                        this.variantChange(variant);
                    });
                });
            }

            getOptionValues(currentVariant) {
                var options = [];
                this.mainElement.productData.options.forEach((option, index) => {
                    if (index == 0) {
                        var optionValues = this.mainElement.productData.variants.map((variant) => {
                            return {
                                value: variant.options[index],
                                available: variant.available
                            }
                        });
                    }
                    if (index == 1) {
                        var optionValues = this.mainElement.productData.variants.filter(x => x.options[0] == currentVariant.option1).map((variant) => {
                            return {
                                value: variant.options[index],
                                available: variant.available
                            }
                        });
                    }
                    if (index == 2) {
                        var optionValues = this.mainElement.productData.variants.filter(
                            x => x.options[0] == currentVariant.option1 && x.options[1] == currentVariant.option2
                        ).map((variant) => {
                            return {
                                value: variant.options[index],
                                available: variant.available
                            }
                        });
                    }
                    var optionValuesUnique = [];
                    optionValues.forEach((option, key) => {
                        if (!optionValuesUnique.find(x => x.value == option.value)) {
                            if (option.available) {
                                optionValuesUnique.push(option);
                            } else {
                                if (!optionValues.find((x, y) => y != key && x.available && x.value == option.value)) {
                                    optionValuesUnique.push(option);
                                }
                            }
                        }
                    });
                    options.push(optionValuesUnique);
                });
                return options;
            }

            refreshOptions(updateOptionIndex = -1, currentVariant) {
                var optionValues = this.getOptionValues(currentVariant);
                this.querySelectorAll('[data-option]').forEach((element, index) => {
                    if (index > updateOptionIndex) {
                        element.buildOptions(optionValues[index], currentVariant.options[index]);
                    }
                    var optionValueElement = element.querySelector('.option-value');
                    if (optionValueElement) {
                        optionValueElement.innerHTML = currentVariant.options[index];
                        if (this.variantTitle)
                            this.variantTitle.textContent = currentVariant.options[0];
                    }
                });
            }
        }

        customElements.define('product-variants', ProductVariants);
    }

    if (!customElements.get('product-swatch')) {
        class ProductSwatch extends HTMLElement {
            constructor() {
                super();
                this.mainElement = this.closest('.product-main-element');
                this.variantsElement = this.closest('product-variants');
                this.optionNumber = this.dataset.option;
                this.label = this.dataset.label;

                this.buildOptionSelector();
            }

            buildOptionSelector() {
                var currentVariant = this.mainElement.getCurrentVariant();
                var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber - 1];
                var defaultValue = currentVariant.options[this.optionNumber - 1];
                var optionElement = document.createElement('div');
                var html = `
  			<div class="option-name">${this.label} <span class="option-value">${defaultValue}</span></div>
  			<div class="swatch-group"></div>
  		`;
                this.innerHTML = html;
                this.buildOptions(optionValues, defaultValue);
            }

            buildOptions(options, defaultValue) {
                var html = '';
                options.forEach((option, index) => {
                    var optionNameHandle = $s.handleize(this.label);
                    var optionValueHandle = $s.handleize(option.value);
                    html += `
          <div class="swatch" data-available="${option.available}">
            <input type="radio" id="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}" value="${option.value}" />
  				  <label for="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}">
              <div class="label-inner ${optionNameHandle}-${optionValueHandle}">
              	<span>${option.value}</span>
              </div>
            </label>
          </div>
  			`;
                });
                var group = this.querySelector('.swatch-group');
                group.innerHTML = html;

                if (defaultValue && group.querySelector('input[value="' + defaultValue + '"]')) {
                    group.querySelector('input[value="' + defaultValue + '"]').checked = true;
                } else {
                    group.querySelector('input').checked = true;
                }
            }
        }

        customElements.define('product-swatch', ProductSwatch);
    }

    if (!customElements.get('product-dropdown')) {
        class ProductDropdown extends HTMLElement {
            constructor() {
                super();
                this.mainElement = this.closest('.product-main-element');
                this.variantsElement = this.closest('product-variants');
                this.optionNumber = this.dataset.option;
                this.label = this.dataset.label;

                this.buildOptionSelector();
            }

            buildOptionSelector() {
                var currentVariant = this.mainElement.getCurrentVariant();
                var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber - 1];
                var defaultValue = currentVariant.options[this.optionNumber - 1];

                var optionId = 's-' + this.mainElement.sectionId + '-option-' + this.optionNumber;
                var optionElement = document.createElement('div');
                var html = `
        <label class="option-name" for="${optionId}">${this.label}</label>
        <select id="${optionId}"></select>
      `;
                this.innerHTML = html;
                this.buildOptions(optionValues, defaultValue);
            }

            buildOptions(options, defaultValue) {

                var html = '';
                options.forEach((option, index) => {
                    let soldOut = (!option.available ? ' - Sold Out' : '');
                    html += `<option value="${option.value}">${option.value}${soldOut}</option>`;
                });
                var select = this.querySelector('select');
                select.innerHTML = html;

                if (defaultValue) {
                    var newValueIndex = Array.from(select.options).findIndex(x => x.value == defaultValue);
                    if (newValueIndex >= 0) {
                        select.selectedIndex = newValueIndex;
                    }
                }
            }
        }

        customElements.define('product-dropdown', ProductDropdown);
    }

    if (!customElements.get('product-model')) {
        class ProductModel extends HTMLElement {
            constructor() {
                super();
                this.mainElement = this.closest('.product-main-element');

                window.Shopify.loadFeatures([{
                    name: 'shopify-xr',
                    version: '1.0',
                    onLoad: this.setupShopifyXr.bind(this)
                }]);
            }

            setupShopifyXr() {
                if (!window.ShopifyXR) {
                    document.addEventListener('shopify_xr_initialized', () => {
                        this.setupShopifyXr();
                    });
                } else {
                    window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x => x.media_type == 'model'));
                    setTimeout(() => {
                        window.ShopifyXR.setupXRElements();
                    }, 100);
                }
            }
        }

        customElements.define('product-model', ProductModel);
    }
    /*
    REF: FEATURE PICKUP AVAILABILITY
    if(!customElements.get('pickup-availability')) {
      class PickupAvailability extends HTMLElement {
        constructor() {
          super();
          this.mainElement = this.closest('product-main');

          this.mainElement.addEventListener('variantChange', (e)=>{
            if(e.detail.variant && e.detail.variant.available) {
              this.fetchAvailability(e.detail.variant.id);
            } else {
              this.innerHTML = '';
            }
          });
        }

        fetchAvailability(variantId) {
          let rootUrl = routes.root;
          if (!rootUrl.endsWith("/")) {
            rootUrl = rootUrl + "/";
          }
          const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

          $s.get({
            url: variantSectionUrl,
            success: (data)=>{
              this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
              this.bindEvents();
            },
            error: ()=>{
              this.innerHTML = '';
            }
          });
        }

        bindEvents() {
          let button = this.querySelector('button');
          if(button) {
            button.addEventListener('click', ()=>{
              $s.openModal(this.querySelector('.pickup-availability-info'), 'test');
            });
          }
        }
      }
      customElements.define('pickup-availability', PickupAvailability);
    }
    */


    
//REF: FEATURE SELLING PLANS
    if (!customElements.get('product-selling-plan')) {
        class ProductSellingPlan extends HTMLElement {
            constructor() {
                super();
                this.mainElement = this.closest('.product-main-element');
                this.input = this.querySelector('[name="selling_plan"]');
                this.groupsContainer = this.querySelector('[data-groups]');
                this.plansContainer = null; //obtained after every group render
                this.textOnetime = this.dataset.textOnetime || "One Time";
                this.textSubscribe = this.dataset.textSubscribe || "Subscribe";
                this.textSubscribeSave = this.dataset.textSubscribesave || "Subscribe \u0026 Save";

                this.input.addEventListener('change', () => {
                    this.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: this.getCurrentPlan()}}));
                });

                this.mainElement.addEventListener('variantChange', (e) => {
                    this.groupsContainer.innerHTML = this.getGroupsHtml();
                    this.plansContainer = this.querySelector('[data-plans]');  //obtained newly generated element

                    this.groupsContainer.querySelectorAll('[name="purchaseOption"]').forEach((groupInput) => {
                        groupInput.addEventListener('change', () => {
                            var plan = this.plansContainer.querySelector('select');
                            //get html with same plan name currently selected
                            this.plansContainer.innerHTML = this.getPlansHtml(plan ? plan.options[plan.selectedIndex].text : '');

                            //only get the select if enabled, otherwise clear selling_plan input value
                            var select = this.plansContainer.querySelector('select.enabled');
                            if (select) {
                                select.addEventListener('change', (e) => {
                                    this.updateSellingPlan(e.target.value);
                                });

                                if (select.querySelector('option[value="' + this.input.value + '"]')) {
                                    select.value = this.input.value;
                                }
                                select.dispatchEvent(new Event('change', {bubbles: true}));
                            } else {
                                this.updateSellingPlan("");
                            }
                        });
                    });

                    var currentPlan = this.getCurrentPlan();
                    if (currentPlan) {
                        var groupInput = this.groupsContainer.querySelector('[value="' + currentPlan.selling_plan_group_id + '"]');
                    } else {
                        var groupInput = this.groupsContainer.querySelector('[name="purchaseOption"]');
                    }
                    groupInput.checked = true;
                    groupInput.dispatchEvent(new Event('change', {bubbles: true}));
                });
            }

            updateSellingPlan(sellingPlanId) {
                this.input.value = sellingPlanId;
                this.input.dispatchEvent(new Event('change', {bubbles: true}));
            }

            getGroupsHtml() {
                var currentVariant = this.mainElement.getCurrentVariant();
                var html = '';

                if (!this.mainElement.productData.requiresSellingPlan) {
                    let optionId = `plan-option-onetime-${this.mainElement.sectionId}`;
                    let optionPrice = $s.formatMoney(currentVariant.price).replace('.00', '');
                    html = `
          <div>
            <input type="radio" name="purchaseOption" value="" id="${optionId}">
            <label for="${optionId}">${this.textOnetime} <span class="option-price"> - ${optionPrice}</span></label>
          </div>
        `;
                }
                if (currentVariant) {
                    this.mainElement.productData.sellingPlanGroups.forEach((group) => {
                        let priceAdjustment = group.selling_plans[0].price_adjustments;
                        let discount = (priceAdjustment && priceAdjustment.length > 0 ? priceAdjustment[0].value : 0); // expected percentage
                        let planAlloc = currentVariant.selling_plan_allocations.find(x => x.selling_plan_group_id == group.id);
                        if (planAlloc) {
                            let optionId = `plan-option-${group.id}-${this.mainElement.sectionId}`;
                            let optionPrice = $s.formatMoney(planAlloc.price).replace('.00', '');
                            html += `
              <div>
                <input type="radio" name="purchaseOption" value="${group.id}" id="${optionId}">
                <label for="${optionId}">` + (discount ? this.textSubscribeSave + ' <span class="option-discount">' + discount + '%</span>' : this.textSubscribe) + ` <span class="option-price"> - ${optionPrice}</span></label>
                <div data-plans></div>
              </div>
            `;
                        }
                    });
                }
                return html;
            }

            getPlansHtml(selectedName) {
                //functionalities:
                // show or hide frequency dropdown when the One-Time option is selected
                // show a div with the frequency option when there is a single option but keep the <select> hidden
                //
                var currentVariant = this.mainElement.getCurrentVariant();
                var enabled = true;
                var currentGroup = this.getCurrentGroup();
                if (!currentGroup) {
                    
                    enabled = false;
                }
                var html = '';

                if (currentGroup) {
                    var isOneOption = currentVariant.selling_plan_allocations.length == 1;
                    selectedName = selectedName.trim();
                    html = '<select class="' + (enabled ? 'enabled' : '') + (isOneOption ? ' hide' : '') + '">';
                    currentVariant.selling_plan_allocations.forEach((plan) => {
                        var sellingPlan = currentGroup.selling_plans.find(x => x.id == plan.selling_plan_id);
                        html += `<option value="${sellingPlan.id}"  ` + (selectedName == sellingPlan.name.trim() ? 'selected="selected"' : '') + `>${sellingPlan.name}</option>`;
                    });
                    html += `</select>`;
                    if (isOneOption) {
                        html += `<div class="selling-plan-name">${currentGroup.selling_plans[0].name}</div>`;
                    }
                }

                return html;
            }

            getCurrentPlan() {
                var currentVariant = this.mainElement.getCurrentVariant();
                if (currentVariant) {
                    return currentVariant.selling_plan_allocations.find(x => x.selling_plan_id == this.input.value);
                }
                return false;
            }

            getCurrentGroup() {
                var groupId = this.querySelector('[name="purchaseOption"]:checked').value;
                return this.mainElement.productData.sellingPlanGroups.find(x => x.id == groupId);
            }
        }

        customElements.define('product-selling-plan', ProductSellingPlan);
    }
    
});